<template>
  <div class="container">
  
        <div class="div-top shadow-bottom">
            <div class="div-header">
                <div class="div-temp"></div>
                <label class="label-header" v-if="userType === 'C'">
                    {{session_data.fortune_name}} 
                </label>
                <label class="label-header" v-if="userType === 'F'">
                    {{session_data.customer_name}} 
                </label>
                <a href="/main" v-if="userType === 'F'">
                    <img class="img-close" src="/images/ic_close.png"/>
                </a>
                <a href="/main" v-if="userType === 'C'">
                    <img class="img-close" src="/images/ic_close.png"/>
                </a>
            </div>
        </div>
        
        <div class="div-center div-chat" v-if="!loading">
            <div v-for="chat in chats" :key="chat.message_id" :set="currentUser = chat.user_type">
                <div v-if="userType === 'C'">
                    <div class="div-chat-item" v-if="chat.user_type === 'F'">
                        <img class="img-fortune" :src="session_data.fortune_image"/>
                        <div class="div-chat-message-left">
                            <label class="label-chat-message" v-if="chat.type == 'text'">
                                <!-- {{htmlFormat(chat.message)}} -->
                                <span v-html="htmlFormat(chat.message)"></span>
                            </label>
                            <label class="" v-if="chat.type == 'image'">
                                <img @click="showImage(chat.message_id)" class="img-messege" :src="chat.message"/>
                                <modal :width="300" :height="400" :name="'mess_'+chat.message_id">
                                    <img style="width: 100%;height:100%" :src="chat.message"/>
                                </modal>
                            </label>
                        </div>
                        <label class="label-updated-date">
                            {{formatDate(chat.sent_date)}} {{chat.sent_time}}
                        </label>
                    </div>

                    <div class="div-chat-item div-chat-item-right" v-if="chat.user_type === 'C'">
                        <label class="label-updated-date label-updated-date-right">
                            {{formatDate(chat.sent_date)}} {{chat.sent_time}}
                        </label>
                        <div class="div-chat-message-right">
                            <label class="label-chat-message message-right" v-if="chat.type == 'text'">
                                <!-- {{htmlFormat(chat.message)}} -->
                                <span v-html="htmlFormat(chat.message)"></span>
                            </label>
                            <label class="message-right" v-if="chat.type == 'image'">
                                <img @click="showImage(chat.message_id)" class="img-messege" :src="chat.message"/>
                                <modal :width="300" :height="400" :name="'mess_'+chat.message_id">
                                    <img style="width: 100%;height:100%" :src="chat.message"/>
                                </modal>
                            </label>
                        </div>
                        
                    </div>
                </div>

                <div v-if="userType === 'F'">
                    <div class="div-chat-item" v-if="chat.user_type === 'C'">
                        <img class="img-fortune" :src="session_data.customer_image"/>
                        <div class="div-chat-message-left">
                            <label class="label-chat-message" v-if="chat.type == 'text'">
                                <!-- {{htmlFormat(chat.message)}} -->
                                <span v-html="htmlFormat(chat.message)"></span>
                            </label>
                            <label class="" v-if="chat.type == 'image'">
                                <img @click="showImage(chat.message_id)" class="img-messege" :src="chat.message"/>
                                <modal :width="300" :height="400" :name="'mess_'+chat.message_id">
                                    <img style="width: 100%;height:100%" :src="chat.message"/>
                                </modal>
                            </label>
                        </div>
                        <label class="label-updated-date">
                            {{formatDate(chat.sent_date)}} {{chat.sent_time}}
                        </label>
                    </div>

                    <div class="div-chat-item div-chat-item-right" v-if="chat.user_type === 'F'">
                        <label class="label-updated-date label-updated-date-right">
                            {{formatDate(chat.sent_date)}} {{chat.sent_time}}
                        </label>
                        <div class="div-chat-message-right">
                            <label class="label-chat-message message-right" v-if="chat.type == 'text'">
                                <!-- {{htmlFormat(chat.message)}} -->
                                <span v-html="htmlFormat(chat.message)"></span>
                            </label>
                            <label class="message-right" v-if="chat.type == 'image'">
                                <img @click="showImage(chat.message_id)" class="img-messege" :src="chat.message"/>
                                <modal :width="300" :height="400" :name="'mess_'+chat.message_id">
                                    <img style="width: 100%;height:100%" :src="chat.message"/>
                                </modal>
                            </label>
                        </div>
                        
                    </div>
                </div>
            </div>
            <div class="chat_box_bottom"></div>
        </div>

        <div class="div-bottom">
            <div class="div-message-box">
                <input @change="handleFileUpload( $event )" type="file" ref="file" style="display: none" accept="image/png, image/gif, image/jpeg" />
                <img @click="$refs.file.value=null;$refs.file.click()" class="img-file" src="/images/btn_file.png"/>
                <!-- <input v-on:keyup.enter="sendMsg" v-model.trim="message" type="text" class="input-message" placeholder="พิมพ์ข้อความ..." /> -->
                <textarea @click="scrollToBottom()" v-model.trim="message" rows="1" class="input-message" placeholder="พิมพ์ข้อความ..." enterkeyhint="enter"></textarea>
                <img class="img-send" src="/images/btn_send.png" @click="sendMsg()" /> 
            </div>
        </div>

    </div>
</template>

<script>
import router from '../router'
import firebase from '../Firebase'
import moment from 'moment'
import axios from 'axios'
import { mapActions, mapState, mapGetters } from "vuex"
import "@/assets/chatroom.css"
export default {
  name: 'Chat',
  data() {
    return {
        chats:[],
        last_message_id: null,
        message: "",
        session_id: this.$route.params.session_id,
        token: this.$route.query.token,
        loading: true,
        session_data: {
            fortune_name: "",
            fortune_image: "",
        },
        currentUser: null,
        chatIds:[]
    }
  },
  props: {
    msg: String
  },
  computed: {
    ...mapGetters({
      userType: "user/getUserType",
      userId: "user/getUserId",
    }),
  },
  methods: {
    getUserType: function() {
      return this.userType;
    },
    getUserId: function() {
      return this.userId;
    },
    async siginWithToken(token) {
      return new Promise((resolve, reject) => {
        firebase.auth().signInWithCustomToken(this.token).then((userCredential) => {
          const user = userCredential.user;
          resolve(userCredential.user.uid)
        })
        .catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;
          resolve(null)
        })
      })
    },
    async findSessionData(session_id) {
        return new Promise((resolve, reject) => {
            var db = firebase.database();
            var ref = db.ref("/sessions/" + session_id);
            ref.once("value", function(snapshot) {
                //console.log(snapshot.val())
                if(snapshot.val() != null)
                    resolve(snapshot.val())
                else  
                    resolve(null)
            })
        })
    },
    async sendMsg() {
        if(this.message != null && this.message.trim() != ''){
            var user_name = ''
            var customer_read = 'N'
            var fortune_read = 'N'
            if(this.getUserType() == 'F'){
                user_name = this.session_data.fortune_name
                customer_read = 'N'
                fortune_read = 'Y'
            }else{
                user_name = this.session_data.customer_name
                customer_read = 'Y'
                fortune_read = 'N'
            }
            var date = moment()
            var data = {
                message_id: date.valueOf(),
                type: 'text',
                user_type: this.getUserType(),
                user: user_name,
                message: this.message,
                sent_date: date.format('YYYY-MM-DD'),
                sent_time: date.format('HH:mm'),
                customer_read: customer_read,
                fortune_read: fortune_read,
            }
            let newData = firebase.database().ref('sessions/' + this.session_id + '/chats').child('msg_'+new Date().getTime())
            newData.set(data);

            let newDataTime = firebase.database().ref('sessions/' + this.session_id + '/last_access')
            newDataTime.set(date.format('YYYY-MM-DD HH:mm:ss'));

            let newDataNoMessage = firebase.database().ref('sessions/' + this.session_id + '/no_message')
            newDataNoMessage.set('N');

            this.message = ''
            this.scrollToBottom()

            let newDataSession = firebase.database().ref('incoming/').child('inc_'+new Date().getTime())
            newDataSession.set({
                session_id: this.session_id,
                incoming_time: date.valueOf(),
                message_id: date.valueOf(),
                user_type: this.getUserType(),
                process: 'N'
            });
            // this.message = ''
            // this.scrollToBottom()
        }
    },
    async sendMsgImage(image) {
        var user_name = ''
        var customer_read = 'N'
        var fortune_read = 'N'
        if(this.getUserType() == 'F'){
            user_name = this.session_data.fortune_name
            customer_read = 'N'
            fortune_read = 'Y'
        }else{
            user_name = this.session_data.customer_name
            customer_read = 'Y'
            fortune_read = 'N'
        }
        var date = moment()
        var data = {
            message_id: date.valueOf(),
            type: 'image',
            user_type: this.getUserType(),
            user: user_name,
            message: image,
            sent_date: date.format('YYYY-MM-DD'),
            sent_time: date.format('HH:mm'),
            customer_read: customer_read,
            fortune_read: fortune_read,
        }
        let newData = firebase.database().ref('sessions/' + this.session_id + '/chats').child('msg_'+new Date().getTime())
        newData.set(data);

        let newDataTime = firebase.database().ref('sessions/' + this.session_id + '/last_access')
        newDataTime.set(date.format('YYYY-MM-DD HH:mm:ss'));
        this.message = ''
        this.scrollToBottom()
        let newDataSession = firebase.database().ref('incoming/').child('inc_'+new Date().getTime())
        newDataSession.set({
            session_id: this.session_id,
            incoming_time: date.valueOf(),
            message_id: date.valueOf(),
            user_type: this.getUserType(),
            process: 'N'
        });
    },
    readMessageCustomer(messageId) {
        var date = moment()
        // let read = firebase.database().ref('sessions/' + this.session_id + '/chats/'+messageId+'/customer_read')
        // read.set('Y')
        // let newDataTime = firebase.database().ref('sessions/' + this.session_id + '/chats/'+messageId+'/customer_readtime')
        // newDataTime.set(date.format('YYYY-MM-DD HH:mm:ss'))
        firebase.database().ref('sessions/' + this.session_id + '/chats/'+messageId).once('value').then((snapshot) => {
            var data = snapshot.val()
            data.customer_read = 'Y'
            data.customer_readtime = date.format('YYYY-MM-DD HH:mm:ss')
            firebase.database().ref('sessions/' + this.session_id + '/chats/'+messageId).set(data)
        });
        // return new Promise((resolve, reject) => {

        //     var date = moment()
        //     // let read = firebase.database().ref('sessions/' + this.session_id + '/chats/'+messageId+'/customer_read')
        //     // read.set('Y')
        //     // let newDataTime = firebase.database().ref('sessions/' + this.session_id + '/chats/'+messageId+'/customer_readtime')
        //     // newDataTime.set(date.format('YYYY-MM-DD HH:mm:ss'))
        //     firebase.database().ref('sessions/' + this.session_id + '/chats/'+messageId).once('value').then((snapshot) => {
        //         var data = snapshot.val()
        //         data.customer_read = 'Y'
        //         data.customer_readtime = date.format('YYYY-MM-DD HH:mm:ss')
        //     });

        //     resolve(true)
        // })
    },
    readMessageFortune(messageId) {
        //console.log(messageId)
        var date = moment()
        firebase.database().ref('sessions/' + this.session_id + '/chats/'+messageId).once('value').then((snapshot) => {
            var data = snapshot.val()
            data.fortune_read = 'Y'
            data.fortune_readtime = date.format('YYYY-MM-DD HH:mm:ss')
            firebase.database().ref('sessions/' + this.session_id + '/chats/'+messageId).set(data)
        });
        // let read = firebase.database().ref('sessions/' + this.session_id + '/chats/'+messageId)
        // read.set('Y')
        // let newDataTime = firebase.database().ref('sessions/' + this.session_id + '/chats/'+messageId+'/fortune_readtime')
        // newDataTime.set(date.format('YYYY-MM-DD HH:mm:ss'))
        // firebase.database().ref('sessions/' + this.session_id + '/chats/'+messageId).once('value').then((snapshot) => {
        //     var data = snapshot.val()
        //     data.fortune_read = 'Y'
        //     data.fortune_readtime = date.format('YYYY-MM-DD HH:mm:ss')
        // });
        // return new Promise(async(resolve, reject) => {
        //     //console.log(messageId)
        //     var date = moment()
        //     // let read = firebase.database().ref('sessions/' + this.session_id + '/chats/'+messageId)
        //     // read.set('Y')
        //     // let newDataTime = firebase.database().ref('sessions/' + this.session_id + '/chats/'+messageId+'/fortune_readtime')
        //     // newDataTime.set(date.format('YYYY-MM-DD HH:mm:ss'))

        //     firebase.database().ref('sessions/' + this.session_id + '/chats/'+messageId).once('value').then((snapshot) => {
        //         var data = snapshot.val()
        //         data.fortune_read = 'Y'
        //         data.fortune_readtime = date.format('YYYY-MM-DD HH:mm:ss')
        //     });

        //     // let read = firebase.database().ref('sessions/' + this.session_id + '/chats/'+messageId+'/fortune_read')
        //     // read.set('Y')
        //     // let newDataTime = firebase.database().ref('sessions/' + this.session_id + '/chats/'+messageId+'/fortune_readtime')
        //     // newDataTime.set(date.format('YYYY-MM-DD HH:mm:ss'))
        // })
    },
    updateMessageImage(messageId, signImageUrl){

        firebase.database().ref('sessions/' + this.session_id + '/chats/'+messageId).once('value').then((snapshot) => {
            var data = snapshot.val()
            data.message = signImageUrl
            firebase.database().ref('sessions/' + this.session_id + '/chats/'+messageId).set(data)
        });
    },
    updateMessageCustomer(messageId, updateRead, message) {
        try{
            var date = moment()
            firebase.database().ref('sessions/' + this.session_id + '/chats/'+messageId).once('value').then((snapshot) => {
                var data = snapshot.val()
                if(updateRead != null){
                    data.customer_read = 'Y'
                    data.customer_readtime = date.format('YYYY-MM-DD HH:mm:ss')
                }
                if(message != null){
                    data.message = message
                }
                firebase.database().ref('sessions/' + this.session_id + '/chats/'+messageId).set(data)
            });
        }catch(e){
            console.log(e)
        }
    },
    updateMessageFortune(messageId, updateRead, message) {
        try{
            var date = moment()
            firebase.database().ref('sessions/' + this.session_id + '/chats/'+messageId).once('value').then((snapshot) => {
                var data = snapshot.val()
                if(updateRead != null){
                    data.fortune_read = 'Y'
                    data.fortune_readtime = date.format('YYYY-MM-DD HH:mm:ss')
                }
                if(message != null){
                    data.message = message
                }
                firebase.database().ref('sessions/' + this.session_id + '/chats/'+messageId).set(data)
            });
        }catch(e){
            console.log(e)
        }
    },
    async loadChat() {
        var _this = this
        try{

            //.startAt(_this.last_message_id)
            ////console.log(`_this.last_message_id = ${_this.last_message_id}`)
            //var starCountRef = firebase.database().ref('sessions/' + this.session_id + '/chats').orderByChild("message_id")
            firebase.database().ref('sessions/' + this.session_id + '/chats').orderByChild("message_id").on('value', async (snapshot) => {
            var arr = Array.from(snapshot);
            ////console.log('arr :: ', snapshot.val())
            var val = snapshot.val()
            for(var key in val){
            // let item = doc.val()
                let item = val[key]
                //console.log(`_this.chatIds : ${_this.chatIds}`)
                item.key = key
                //////console.log(item.key, _this.chatIds, _this.chatIds.includes(item.key))
                if(!_this.chatIds.includes(item.key)){
                    _this.last_message_id = item.message_id
                    var signUrlNew = null
                    if(item != null && item.type == 'image'){
                        var expires = item.message.substring(item.message.indexOf('Expires='))
                        expires = expires.substring(expires.indexOf('=')+1, expires.indexOf('&'))
                        var expTime = moment.unix(expires)
                        if(moment().isAfter(expTime)){
                            console.log(`now: ${moment()}, expTime : ${expTime}, expires=${expires}, image need to sign url`)
                            const signImageUrl = await _this.signImage(item.message)
                            item.message = signImageUrl
                            signUrlNew = signImageUrl

                            //_this.updateMessageImage(item.key, signImageUrl)
                            // snapshot.set(item)
                        }else{
                            console.log('no need to sign url')
                        }

                        //console.log(`expTime : ${expTime}, expires=${expires}, after=${moment().isAfter(expTime)}`)
                        
                        
                    }
                    //////console.log(item.key, item)
                    if(_this.userType == 'C'){
                        var updateRead = null
                        if(item.customer_read == 'N'){
                            //_this.readMessageCustomer(item.key)
                            updateRead = 'Y'
                        }
                        _this.updateMessageCustomer(item.key, updateRead, signUrlNew)
                    }else if(_this.userType == 'F'){
                        var updateRead = null
                        if(item.fortune_read == 'N'){
                            //_this.readMessageFortune(item.key)
                            updateRead = 'Y'
                        }
                        _this.updateMessageFortune(item.key, updateRead, signUrlNew)
                    }
                    var found = false
                    for(var c of _this.chats){
                        if(c.message_id == item.message_id){
                            found = true
                        }
                    }
                    if(!found){
                        _this.chats.push(item)
                    }
                    _this.chatIds.push(item.key)
                }
            }
            // snapshot.forEach((doc) => {
            //   let item = doc.val()
            //   item.key = doc.key
            //   ////console.log(item.key, _this.chatIds, _this.chatIds.includes(item.key))
            //   if(!_this.chatIds.includes(item.key)){
            //     if(item != null && item.type == 'image'){
            //        item.message = _this.signImage(item.message)
            //     }
            //     _this.chats.push(item)
            //     ////console.log(item.key, item)
            //     if(_this.userType == 'C'){
            //         if(item.customer_read == 'N'){
            //             _this.readMessageCustomer(item.key)
            //         }
            //     }else if(_this.userType == 'F'){
            //         if(item.fortune_read == 'N'){
            //             _this.readMessageFortune(item.key)
            //         }
            //     }
            //     _this.chatIds.push(item.key)
            //   }
            // });
            })
        }catch(e){
            //console.log(e)
            firebase.database().ref('sessions/' + this.session_id + '/chats').off()
            this.loadChat()
        }
        
    },
    async loadChat2() {
        var _this = this
        try{

            //.startAt(_this.last_message_id)
            //console.log(`_this.last_message_id = ${_this.last_message_id}`)
            firebase.database().ref('sessions/' + this.session_id + '/chats').orderByChild("message_id").on('value', (snapshot) => {
                snapshot.forEach((doc) => {
                let item = doc.val()
                item.key = doc.key
                ////console.log(item.key, _this.chatIds, _this.chatIds.includes(item.key))
                if(!_this.chatIds.includes(item.key)){
                    if(item != null && item.type == 'image'){
                    item.message = _this.signImage(item.message)
                    }
                    _this.chats.push(item)
                    ////console.log(item.key, item)
                    if(_this.userType == 'C'){
                        if(item.customer_read == 'N'){
                            _this.readMessageCustomer(item.key)
                        }
                    }else if(_this.userType == 'F'){
                        if(item.fortune_read == 'N'){
                            _this.readMessageFortune(item.key)
                        }
                    }
                    _this.chatIds.push(item.key)
                }
                });
            })
        }catch(e){
            //console.log(e)
            firebase.database().ref('sessions/' + this.session_id + '/chats').off()
            this.loadChat()
        }
        
    },
    async loadChatList() {
        var _this = this
        //.startAt(1658400096366)
        _this.chats = [];
        _this.chatIds = [];

        firebase.database().ref('sessions/' + this.session_id + '/chats').orderByChild("message_id").on('value', async (snapshot) => {
        var arr = Array.from(snapshot);
        //console.log('arr :: ', snapshot.val())
        //console.log('chats :: ', _this.chats)
        var val = snapshot.val()
        for(var key in val){
           // let item = doc.val()
            let item = val[key]
            item.key = key
            ////console.log(item.key, _this.chatIds, _this.chatIds.includes(item.key))
            var isExist = false
            for(var chat of _this.chats){
                if(item.message_id == chat.message_id){
                    isExist = true
                }
            }
            //console.log(item.message_id , isExist, item)
            if(!isExist){
                //_this.last_message_id = item.message_id
                if(item != null && item.type == 'image'){
                    item.message = await _this.signImage(item.message)
                }
                ////console.log(item.key, item)
                if(_this.userType == 'C'){
                    if(item.customer_read == 'N'){
                        _this.readMessageCustomer(item.key)
                    }
                }else if(_this.userType == 'F'){
                    if(item.fortune_read == 'N'){
                        _this.readMessageFortune(item.key)
                    }
                }
                _this.chats.push(item)
                _this.chatIds.push(item.key)
            }
            // if(!_this.chatIds.includes(item.key)){
            //     _this.last_message_id = item.message_id
            //     if(item != null && item.type == 'image'){
            //         item.message = await _this.signImage(item.message)
            //     }
            //     ////console.log(item.key, item)
            //     if(_this.userType == 'C'){
            //         if(item.customer_read == 'N'){
            //             _this.readMessageCustomer(item.key)
            //         }
            //     }else if(_this.userType == 'F'){
            //         if(item.fortune_read == 'N'){
            //             _this.readMessageFortune(item.key)
            //         }
            //     }
            //     _this.chats.push(item)
            //     _this.chatIds.push(item.key)
            // }
        }
      });
    },

    async loadChatOneTime() {
        var _this = this
        //.startAt(1658400096366)
        firebase.database().ref('sessions/' + this.session_id + '/chats').orderByChild("message_id").on('value', async (snapshot) => {
        _this.chats = [];
        _this.chatIds = [];

        var arr = Array.from(snapshot);
        //console.log('arr :: ', snapshot.val())
        var val = snapshot.val()
        for(var key in val){
           // let item = doc.val()
            let item = val[key]
            item.key = key
            ////console.log(item.key, _this.chatIds, _this.chatIds.includes(item.key))
            if(!_this.chatIds.includes(item.key)){
                _this.last_message_id = item.message_id
                if(item != null && item.type == 'image'){
                    item.message = await _this.signImage(item.message)
                }
                _this.chats.push(item)
                ////console.log(item.key, item)
                if(_this.userType == 'C'){
                    if(item.customer_read == 'N'){
                        _this.readMessageCustomer(item.key)
                    }
                }else if(_this.userType == 'F'){
                    if(item.fortune_read == 'N'){
                        _this.readMessageFortune(item.key)
                    }
                }
                _this.chatIds.push(item.key)
            }
        }
        firebase.database().ref('sessions/' + this.session_id + '/chats').off()
        this.loadChat()
      });
    },
    htmlFormat(message){
        return message.replace(/(?:\r\n|\r|\n)/g, '<br>')
    },
    formatDate(date){
        ////console.log(date)
        var dateString = ''
        if(moment().format('YYYY-MM-DD') == date){
            dateString = 'วันนี้'
        }else if(moment().add(-1, 'days').format('YYYY-MM-DD') == date){
            dateString = 'เมื่อวานนี้'
        }else{
            dateString = moment().add(543, 'years').format('DD/MM/YYYY')
        }
        return dateString
    },
    scrollToBottom() {
        // alert('aa')
        const el = this.$el.getElementsByClassName('chat_box_bottom')[0]
        if (el) {
            el.scrollIntoView({behavior: 'smooth'})
        }
    },
    handleFileUpload( event ){
        var _this = this
        var file = event.target.files[0];
        console.log(file)
        console.log(file.type)
        if(file.type == 'image/jpeg'|| file.type == 'image/jpg' ||file.type == 'image/png'){
            if(file.size < 6000000){
                let formData = new FormData();
                formData.append('upload', file);
                //alert(this.$cookies .get('token'));
                axios.post( process.env.VUE_APP_API_URL+'/api/v1/image/upload/secure',
                    formData,
                    {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Authorization' : 'Bearer '+this.$cookies .get('sessionToken')
                    }
                }).then(function(response){
                    try{
                        //console.log('SUCCESS!!', response.data.data.image_url);
                        _this.sendMsgImage(response.data.data.image_url)
                    }catch(e){
                        //console.log(e)
                    }
                }).catch(function(e){
                    //console.log('FAILURE!!', e);
                })
        
            }else{
                alert('กรุณาใช้รูปขนาดไม่เกิน 5MB')
            }
        }else{
            alert('กรุณาอัพโหลดรูปเท่านั้น')
        }
    },
    showImage(id){
        //alert(image)
        const modalId = 'mess_'+id.toString()+''
        this.$modal.show(modalId);
        // this.$modal.show({
        //     template: `
        //         <div>
        //         <img src=`+image+` />
        //         </div>
        //     `
        // })
        
    },
    signImage2: function (image_url) {
        return this.signImage(image_url)
    },
    signImage: async function (image_url) {
        var body = {
            image_url: image_url
        }
        let result = await axios.post(
                process.env.VUE_APP_API_URL+'/api/v1/image/sign', 
                body, 
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization' : 'Bearer '+this.$cookies .get('sessionToken')
                    }
                }
        )
        return result.data.url
        // return new Promise((resolve, reject) => {
        //     var body = {
        //         image_url: image_url
        //     }
        //     axios.post(
        //             'https://api-dev.horoforallplf.com/api/v1/image/sign', 
        //             body, 
        //             {
        //                 headers: {
        //                     'Content-Type': 'application/json',
        //                     'Authorization' : 'Bearer '+this.$cookies .get('sessionToken')
        //                 }
        //             }
        //     ).then(response => {
        //         if(response !=null && response.data != null){
        //             //console.log(response.data.url);
        //             resolve(response.data.url)
        //         }
        //     });
        // })
    },
    interim: function () {
        const self = this;          
        this.intervalid1 = setInterval(function(){
            if(this.userType == 'F'){
                let interimData = firebase.database().ref('connection/'+self.userId)
                interimData.set({
                    connect_time: moment().valueOf()
                });
            }else{
                let interimData = firebase.database().ref('connection/'+self.userId)
                interimData.set({
                    connect_time: moment().valueOf()
                });
            }
            
        }, 10000);
    }
  },
  updated() {
      this.scrollToBottom()
  },
  async mounted() {
      
      //console.log(process.env)
    //alert(this.$cookies .get('token'));
    const uid = await this.getUserId()
    //const uid = await this.siginWithToken(this.token)
    //console.log('uid ::: ', uid)
    if(uid != null){
        try{
            //console.log('session_id ::: ', this.session_id)
            const session_data = await this.findSessionData(this.session_id)
            // //console.log('uid ::: ', uid)
            
            //console.log('session_data : ', session_data)
            this.session_data = session_data
            this.loading = false
            // this.loadChatOneTime()
            // this.loadChatList()
            this.loadChat()

            this.interim()
        }catch(e){
            //console.error(e)
        }

        // var connectedRef = firebase.database().ref('.info/connected');
        // connectedRef.on('value', (snap) => {
        //     alert(snap.val())
        //     let read = firebase.database().ref('connected/status')
        //     read.set('N')
        // });

        // firebase.database().ref('incoming').orderByChild("message_id").limitToLast(3).on('value', (data) => {
        //     //console.log(data.val())
        // })
    }else{
        router.push(`/error`) 
    }
    //console.log('uid : ', uid)
  }
}
</script>
